import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { CheckedIconMapper, IconMapper } from "../../../constants/WebMap";

const CommonTypeTabsGroup = ({ data = [], value, handleChange = () => { }, handleClick, icon, title }) => {
  const controlProps = (item) => ({
    inputProps: { "aria-label": item },
  });

  return (
    <>
      <FormControl style={{ width: "100%" }}>
        {title && <div
          style={{
            marginBottom: "10px",
            textAlign: "left",
            font: "normal normal 550 13px/18px Open Sans",
            color: "black"
          }}
        >
          {title}
        </div>}
        <RadioGroup
          row
          aria-labelledby={"radio-group-horizontal"}
          name={"radio-group-horizontal"}
          value={value}
          {...(handleClick && {
            onClick: (e) => {
              if (e.target.value) handleClick(e.target.value);
            }
          })}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          style={{ width: "100%", display: "flex" }}
        >
          {data.map((item, idx) => (
            <FormControlLabel
              key={idx}
              value={item.value}
              sx={{
                m: 0,
                mb: data.length > 6 ? "8px" : 0,
                minWidth: "40px",
                flex: 1,
                height: "20px",
                display: "flex",
                justifyContent: "center",
                ...(item.value === value && {
                  backgroundColor: "#007842",
                  color: "white",
                }),
                borderRadius: `${idx === 0 && idx === data.length - 1
                    ? "12px 12px 12px 12px"
                    : idx === 0
                      ? "12px 0px 0px 12px"
                      : idx === data.length - 1 && "0px 12px 12px 0px"
                  }`,
                border: "1px solid rgba(0, 120, 66, 0.5)",
                ".MuiFormControlLabel-label": {
                  fontSize: 13,
                },
              }}
              disabled={item.disabled}
              control={
                <Radio
                  {...controlProps({ label: item.label })}
                  sx={{
                    display: "none",
                  }}
                />
              }
              label={
                icon ? (
                  <div
                    style={{
                      height: "15px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "2px 0px",
                    }}
                  >
                    {IconMapper[`${item.label}`] && (
                      <img
                        src={
                          item.value === value
                            ? CheckedIconMapper[`${item.label}`]
                            : IconMapper[`${item.label}`]
                        }
                        alt={item.label}
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                        vertical-align="middle"
                      />
                    )}
                    {!IconMapper[`${item.label}`] && (
                      <span style={{ wordBreak: "break-word" }}>
                        {" "}
                        {item.label}{" "}
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      height: "14px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        fontSize: "10px",
                        maxWidth: "50px",
                      }}
                    >
                      {" "}
                      {item.label}{" "}
                    </span>
                  </div>
                )
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default CommonTypeTabsGroup;
